import { render, staticRenderFns } from "./FeedbackFollowup.vue?vue&type=template&id=34aa8b9d&scoped=true&"
import script from "./FeedbackFollowup.vue?vue&type=script&lang=ts&"
export * from "./FeedbackFollowup.vue?vue&type=script&lang=ts&"
import style0 from "./FeedbackFollowup.vue?vue&type=style&index=0&id=34aa8b9d&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34aa8b9d",
  null
  
)

export default component.exports